const loadingLabel = "Cargando";
const esES = {
  loadingLabel
};
export {
  esES as default,
  loadingLabel
};
